import { SDKError } from "@smash-sdk/core";
export class GenericError extends SDKError {
    constructor() {
        super(...arguments);
        this.name = "GenericError";
    }
}
export class BadRequestError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "BadRequestError";
    }
}
export class UnauthorizedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "UnauthorizedError";
    }
}
export class FobiddenError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "FobiddenError";
    }
}
export class NotFoundError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "NotFoundError";
    }
}
export class InternalServerError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InternalServerError";
    }
}
export class BadGatewayError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "BadGatewayError";
    }
}
export class GatewayTimeoutError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "GatewayTimeoutError";
    }
}
export default {
    GenericError,
    BadRequestError,
    UnauthorizedError,
    FobiddenError,
    NotFoundError,
    InternalServerError,
    BadGatewayError,
    GatewayTimeoutError,
};
